export var createMuiToggleButtonOverrides = function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    return ({
        root: {
            border: undefined,
            color: palette.text.primary,
            "&:hover": {
                backgroundColor: palette.action.hover,
            },
            "&$selected": {
                color: undefined,
                backgroundColor: palette.action.active,
            },
            "&.Mui-focusVisible": {
                boxShadow: "inset 0 0 0 1px ".concat(palette.text.primary),
                backgroundColor: palette.action.focus,
            },
        },
        sizeSmall: {
            padding: spacing(1),
        },
    });
};
//# sourceMappingURL=MuiToggleButton.js.map